import { useHttpClient } from '@/common/api/httpClient';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import type { MapStyleResponse } from 'shared/mapStyles/api/mapStyleResponse';

export interface GetMapStylesRequest {
  styleId: string;
}

export interface GetMapStyleResponse {
  style: MapStyleResponse;
}

export function useGetMapStyle() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: GetMapStylesRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`mapStyle/${action.styleId}`), {
      method: 'GET',
      headers,
    });

    const text = translations.value.mapStyles.actions.fetch;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as GetMapStyleResponse;
        return {
          ok: true,
          style: json.style
        };
      },
    });

    return response;
  }
}
